export const ORIENTATION = {
    Horizontal: 'horizontal',
    Vertical: 'vertical',
};
export const WEIGHT = {
    Light: 'light',
    Regular: 'regular',
};
